// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener('flu:cart:item-added', function (evt) {
  console.log('Item added to the cart', evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener('flu:cart:updated', function (evt) {
  console.log('Cart updated', evt.detail.cart);
}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener('flu:cart:error', function (evt) {
  console.log(evt.detail.errorMessage, 'Cart error');
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener('flu:quick-cart:open', function (evt) {
  console.log('Quick cart opened', evt.detail.cart);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener('flu:quick-cart:close', function () {
  console.log('Quick cart closed');
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener('flu:product:variant-change', function (evt) {
  console.log('Product variant changed', evt.detail.variant);



  /**** BACK IN STOCK FORM ***/
  setTimeout(function(){
    if($(".product-form__cart-submit").attr("disabled") == "disabled" && $(".product-form__cart-submit").text().indexOf("Indisponible")<0){
      $(".klaviyo-back-in-stock").show();
      $(".product-form__submit-button-wrapper").hide()
    }else{
      $(".klaviyo-back-in-stock").hide();
      $(".product-form__submit-button-wrapper").show()
    }
  },1000);

/****/
  /** UPDATE FIELDS DEPENDING ON SELECTED VARIANT **/

  if(typeof available_options !== "undefined"){
    let clickedElem = evt.target.activeElement;
    let clickedOptionName = "";
    let clickedOptionValue = "";
    if($(clickedElem).attr("class") == "product-form__option-select"){
      clickedOptionName = "Matière";
      clickedOptionValue = $(clickedElem).val();
    }else if($(clickedElem).parent().parent().attr("class") == "product-form__color-swatches") {
      clickedOptionName = "Couleur";
      clickedOptionValue = $(clickedElem).attr("aria-label");
    }else{
      clickedOptionName = "Taille";
      clickedOptionValue = $(clickedElem).attr("aria-label");
    }
  
    if(clickedOptionName == "Matière"){
      let curr_selection_availabilities = available_options[clickedOptionValue];
      $(".product-form__option button").hide();
      for(option of curr_selection_availabilities){
        console.log(option);
        $("button[aria-label='"+option+"']").show()
      }
      $(".product-form__color-swatches button").first().click();
    } 
    
    /*if(clickedOptionName == "Couleur"){
      let curr_selection_availabilities = available_options[clickedOptionValue];
      $(".product-form__option button").hide();
      $(".product-form__color-swatches button").show();
      $(".product-form__option-select option").hide();
      for(option of curr_selection_availabilities){
        console.log(option);
        $("button[aria-label='"+option+"']").show()
        $(".product-form__option-select option[value='"+option+"']").show();
        $(".product-form__option-select").val(option);
      }
    }*/
    console.log(clickedElem);
    console.log(clickedOptionName);
    console.log(clickedOptionValue);
  }

  
  let currVarID = evt.detail.variant == null ? $("[data-variant-select]").val() : evt.detail.variant.id;
  let elemCompoEtEntretien = $("[id*='accordion--composition-et-entretien']");
  let elemGuideTailles = $("[id*='accordion--guide-des-tailles']");
  let elemDescription = $("[id*='product-description--description']");
  let elemShortDescription = $(".scroll-description h2");
  let elemTitleGal = $(".gallery-ex-var .text-block__heading");
  if(typeof variants_metafields != 'undefined'){
    if(typeof variants_metafields[currVarID] != 'undefined'){
      console.log(variants_metafields[currVarID]);
      if(typeof variants_metafields[currVarID].img_var!='undefined' && variants_metafields[currVarID].img_var!=null){
        let variantImgs = variants_metafields[currVarID].img_var
        var i = 0;
        for(img of variantImgs){
          let imgsrc = img.src ? img.src : img;
          $(".gal_img_var_"+i).attr("srcset","");
          $(".gal_img_var_"+i).attr("src",imgsrc);
          i++;
        }
      }
      if(typeof variants_metafields[currVarID].title_gallery!='undefined' && variants_metafields[currVarID].title_gallery!=null){
        let variantTitleGal = variants_metafields[currVarID].title_gallery
        $(elemTitleGal).html(variantTitleGal);
      }
      if(typeof variants_metafields[currVarID].compo_entretien!='undefined' && variants_metafields[currVarID].compo_entretien!=null){
        let variantCompoEtEntretien = variants_metafields[currVarID].compo_entretien
        $(elemCompoEtEntretien).html(variantCompoEtEntretien);
      }
      if(typeof variants_metafields[currVarID].description_variante!='undefined' && variants_metafields[currVarID].description_variante!=null){
        $(".desc__variant__dynamic").remove();
        let variantDesc = variants_metafields[currVarID].description_variante
        let variantPicto = variants_metafields[currVarID].picto
        $(elemDescription).prepend("<div class='desc__variant__dynamic'>"+variantDesc+variantPicto+"</div>");
      }
      if(typeof variants_metafields[currVarID].description_courte!='undefined' && variants_metafields[currVarID].description_courte!=null){
        let variantShortDescription = variants_metafields[currVarID].description_courte
        $(elemShortDescription).text($(variantShortDescription).text());
      }
      if(typeof variants_metafields[currVarID].guide_tailles!='undefined' && variants_metafields[currVarID].guide_tailles!=null){
        let variantGuideTailles = variants_metafields[currVarID].guide_tailles
        $(elemGuideTailles).html(variantGuideTailles);
      }
    }
  }
  /*********/
  /** ALMA INDICATION PRICE DEPENDING ON VARIANT PRICE ***/
  let var_price = evt.detail.variant == null ? parseInt($("[data-product-price]").html().replace("€","").replace(",","")) : evt.detail.variant.price;
  if(var_price>=5000){
    $(".alma-3x").html("<small>ou en 3x"+(var_price/3/100).toFixed(2)+"€ sans frais avec Alma</small>");
    $(".alma-update-price").html("Payez en 3 x "+(var_price/3/100).toFixed(2)+"€ sans frais.");
  }else{
    $(".alma-3x").html("");
    $(".alma-update-price").html("Uniquement pour les articles de 50€ ou plus.");
  }
  /*********/

  
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener('flu:product:quantity-update', function (evt) {
  console.log('Product quantity updated', evt.detail.quantity, evt.detail.variant);
});


